import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ClientsSlice";
import ClientsComponent from "./ClientsComponent";
import { GetUserId } from "../../../_utilities/getUserInfo";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";

const initalState = { data: null, message: "", isloader: true };

const ClientsCreate = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [customFieldsArray, setCustomFieldsArray] = useState([]);

  const code = useSelector((state) => state.AddClients.data);
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    const init = async () => {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    };
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customPostingFieldsData = data.filter((x) => x.moduleId.toString() === "3");
      if (customPostingFieldsData.length > 0) {
        let Array = {};
        customPostingFieldsData.forEach((item) => {
          item.customValues =
            item.dataType.toLowerCase() !== "text box"
              ? JSON.parse(item.customValues)
              : "";
          item.moduleId = item.moduleId.toString();
          Array[item.fieldName] =
            item.dataType.toLowerCase() !== "text box" ? [] : "";
        });
        setCustomFieldsArray(customPostingFieldsData);
      }
    }
  }, [customFieldsData]);

  const handleValidData = async (clients) => {
    setDisableSubmitBtn(true);
    if (props.componentType === "Edit") {
      props.onValidData(clients);
    } else {
      dispatch(_ser.addClientsAsync(clients))
        .then(() => {
          setDisableSubmitBtn(false);
        })
        .catch(() => {
          setDisableSubmitBtn(false);
        });
    }
  };

  useEffect(() => {
    if (code === 200) {
      dispatch(_ser.addClientsStartReducer(initalState));
      if (props.onClose) {
        props.onClose();
      } else {
        navigate("/ats/layout/clients/landing");
      }
    }
  }, [code, props.onClose, navigate, dispatch]);

  return (
    <ClientsComponent
      {...props}
      customFieldsArray={customFieldsArray}
      onValidData={handleValidData}
      disableBtn={disableSubmitBtn || props.disableBtn}
    />
  );
};

export default ClientsCreate;
